import {
  Chip,
  Typography,
  Box,
  Divider,
  Button,
  // FormGroup,
  // FormControlLabel,
  // Checkbox,
  Grid,
} from "@mui/material";
import React from "react";
import "./Property.css";
import Connection from "../components/Connection";
import PlansModal from "../components/PlansModal";
import { useLocation } from "react-router-dom";
import moment from "moment";

import Plug from "../assets/plug.png";
import axios from "axios";

function Property(props) {
  const [connections, setConnections, handleUpdateConnections] = [
    props.connectionsState.connections,
    props.connectionsState.setConnections,
    props.connectionsState.handleUpdateConnections,
  ];

  const plans = props.plans;

  const [openPlans, setOpenPlans] = React.useState(false);
  const [existingPlans, setExistingPlans] = React.useState(false);

  const [sharedConnectionAnswers, setSharedConnectionAnswers] =
    React.useState(false);

  const location = useLocation();

  const loadPreviousCartFromDB = () => {
    let userEmail = props.user[7].Value;
    axios
      .get(
        "https://b3bq9zjyp4.execute-api.ap-southeast-2.amazonaws.com/api/connection/email/" +
          userEmail
      )
      .then((response) => {
        // console.log("Here's all their plans!");
        // console.log(response);
        let newConnections = response.data.data.map((e) => {
          e.initialDBFlag = true;
          e.moveInDate = moment(e.moveInDate, "DD/MM/yyyy");
          return e;
        });

        newConnections = newConnections.filter(
          // FILTER OUT PLANS THAT ARE NOT AVAILABLE
          (item) =>
            item.planName === "saSmartBusinessPlan" ||
            item.planName === "saSustainableHomePlan"
        );
        if (newConnections.length !== 0) {
          setConnections(newConnections);
          setExistingPlans(true);
        }
      });
  };

  React.useEffect(() => {
    let search = new URLSearchParams(location.search);
    let query = search.get("plan");
    loadPreviousCartFromDB();
    if (query && connections.length === 0) {
      if (
        query === "saSustainableHomePlan" ||
        query === "saSmartBusinessPlan"
      ) {
        addItem(query);
      } else {
        return;
      }
    }
    // eslint-disable-next-line
  }, []);

  const handleAddConnection = () => {
    let confirmed = true;
    if (connections.length !== 0) {
      connections.forEach((e) => {
        if (e.confirmed === false) {
          confirmed = false;
        }
      });
    }
    if (confirmed) {
      setOpenPlans(true);
    } else {
      alert("Please complete current plan details before adding a new plan.");
    }
  };

  const handleClosePlans = () => setOpenPlans(false);

  // const handleSharedConnectionsAnswersChange = () => {
  //   setSharedConnectionAnswers(!sharedConnectionAnswers);
  // };

  const addItem = (planName) => {
    let newConnections = [...connections];
    newConnections.push({
      connectionId: "",
      planName: planName,
      formattedPlanName: plans[planName].formattedPlanName,
      planDescriptor: plans[planName].planDescriptor,
      address: {
        description: "",
        streetNo: "",
        streetName: "",
        streetType: "",
        suburb: "",
        state: "",
        postcode: "",
      },
      nmi: "",
      moveInFlag: "",
      moveInDate: null,
      concessionFlag: "",
      concessionCardType: "",
      concessionCardNumber: "",
      concessionCardExpiryDate: "",
      lifeSupportFlag: "",
      lifeSupportMachineType: "",
      solarFlag: "",
      lifeSupportNotes: "",
      confirmed: false,
      abn_number: "",
      business_name: "",
    });
    setConnections(newConnections);
    handleClosePlans();
  };

  React.useEffect(() => {
    if (sharedConnectionAnswers) {
      let newConnections = connections;
      if (connections.length === 1) {
        setSharedConnectionAnswers(false);
      }
      newConnections.slice(1).forEach((e) => {
        e.moveInFlag = connections[0].moveInFlag;
        e.solarFlag = connections[0].solarFlag;
        e.concessionFlag = connections[0].concessionFlag;
        e.lifeSupportFlag = connections[0].lifeSupportFlag;
      });
      setConnections(newConnections);
    }
    // eslint-disable-next-line
  }, [connections, props.cart]);

  React.useEffect(() => {
    handleUpdateConnections();
    // eslint-disable-next-line
  }, [existingPlans]);

  return (
    <form name="PropertiesForm">
      <Box>
        <Typography variant="h2">Connection Details</Typography>

        {props.connectionsState.connections.length !== 0 ? (
          <Typography variant="subtitle1" sx={{ m: 1 }}>
            Fill out the form to connect one or more properties
          </Typography>
        ) : (
          <Typography variant="subtitle1" sx={{ m: 1 }}>
            Click 'add connection' to switch to iO Energy
          </Typography>
        )}

        <Box
          sx={{ maxHeight: "65vh", overflow: "auto" }}
          id="connections-list-wrapper"
        >
          {props.connectionsState.connections.map((item, index) => {
            return (
              <Box
                key={index}
                name={index}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "4px",
                }}
              >
                <Connection
                  connectionsState={{
                    connections,
                    setConnections,
                    handleUpdateConnections,
                    sharedConnectionAnswers,
                  }}
                  item={item}
                  index={index}
                  cart={props.cart}
                  user={props.user}
                  cafState={props.cafState}
                  mediaQuery={props.mediaQuery}
                  handleDeleteConnection={props.handleDeleteConnection}
                  setOpenPlans={setOpenPlans}
                />
              </Box>
            );
          })}
          {/* {props.connectionsState.connections.length > 1 ? (
            <FormGroup id="same-answers-checkbox" sx={{ m: 1 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={handleSharedConnectionsAnswersChange}
                    name="useSharedAnswers"
                  />
                }
                label={
                  <Typography variant="body" color={"gray"}>
                    Use the same answers for additional connections?
                  </Typography>
                }
              />
            </FormGroup>
          ) : (
            <></>
          )} */}

          {connections.length !== 0 ? (
            <>
              <Divider sx={{ mt: 3 }}>
                <Chip
                  onClick={handleAddConnection}
                  label="+ Connect Another Property"
                />
              </Divider>
            </>
          ) : (
            <>
              <Button
                sx={{ mt: 4 }}
                variant="outlined"
                onClick={handleAddConnection}
                data-cy="add-connection-button"
              >
                + ADD CONNECTION
              </Button>
              <Grid container justifyContent="center" sx={{ mt: 5 }}>
                <img src={Plug} width="40%" height="auto" alt="" />
              </Grid>
            </>
          )}
        </Box>
        <PlansModal
          open={openPlans}
          handleClose={handleClosePlans}
          addItem={addItem}
          plans={plans}
        />
      </Box>
    </form>
  );
}

export default Property;
